const serialURL = "/api/serial";
const qrrangeURL = "/api/qrrange";
const statsURL = "/api/stats";
const addBoxURL = "/api/addbox";
const removeBoxURL = "/api/removebox";
const enquireBoxURL = "/api/enquire";
const addUserURL = "/api/user";
const userLoginURL = "/api/login";
const userLogoutURL = "/api/logout";
const productURL = "/api/product";
const productsURL = "/api/products";
const passwordURL = "/api/password";

const fetchSerialNumber_local = async () => {
  //let url = api_uri + serialURL;
  //console.log(`api_uri: ${api_uri}.`);
  //console.log(`serialURL: ${serialURL}.`);
  //console.log(`url: ${url}.`);
  try {
    const res = await fetch(serialURL, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    console.log(`res.status: ${res.status}.`);
    if (res) {
      console.log("trying to read serial");
      const data = await res.json();
      data.status = res.status;
      return data;
    } else {
      console.log("dont read serial - return null");
      return null;
    }
  } catch (error) {
    console.log(`Error fetching ${serialURL}: ${error}`);
  }
};

const sendQRCodeRange_local = async (payload) => {
  try {
    const res = await fetch(qrrangeURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    console.log(`res.status: ${res.status}.`);
    if (res) {
      console.log("send QR range is sent successfully");
      const data = await res.json();
      data.status = res.status;
      return data;
    } else {
      console.log("could not send QR range - return null");
      return null;
    }
  } catch (error) {
    console.log(`Error sending ${qrrangeURL}: ${error}`);
    return null;
  }
};

const fetchStats = async () => {
  console.log("fetchStats is called by fetchDataStats.");
  //const { user } = useUserfront();
  try {
    const res = await fetch(statsURL, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    console.log(`res.status: ${res.status}.`);
    if (res) {
      const data = await res.json();
      data.status = res.status;
      return data;
    } else {
      console.log("could not get data stats - return null");
      return null;
    }
  } catch (error) {
    console.log(`Error fetching ${statsURL}: ${error}`);
  }
};

const enquireBox_local = async (data) => {
  //const { user } = useUserfront();
  try {
    const res = await fetch(enquireBoxURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    console.log(`res.status: ${res.status}.`);
    if (res) {
      console.log("enquire get is sent successfully");
      const data = await res.json();
      data.status = res.status;
      return data;
    }
  } catch (error) {
    console.log(`Unable to enquire box, error: ${error}.`);
    return null;
  }
};

//data could be {addUsingSN: true, serialNumber: serialNumber} or {addUsingSN: false, ...box} depending on whether we are adding a box using serial number or using box object
const addBox_local = async (data) => {
  try {
    const res = await fetch(addBoxURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //Authorization: `Bearer ${Userfront.tokens.accessToken}`,
      },
      body: JSON.stringify(data),
    });
    console.log(`res.status: ${res.status}.`);
    if (res) {
      console.log("add post is sent successfully");
      const data = await res.json();
      data.status = res.status;
      return data;
    }
  } catch (error) {
    console.log("Unable to add box.");
    return null;
  }
};

//data is {serialNumber: serialNumber} 
const removeBox_local = async (data) => {
  try {
    const res = await fetch(removeBoxURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //Authorization: `Bearer ${Userfront.tokens.accessToken}`,
      },
      body: JSON.stringify(data),
    });
    console.log(`res.status: ${res.status}.`);
    if (res) {
      console.log("remove post is sent successfully");
      const data = await res.json();
      data.status = res.status;
      return data;
    }
  } catch (error) {
    console.log("Unable to remove box.");
    return null;
  }
};

const addUser_local = async (username, email, hashedKilma, hashedSkilma) => {
  let data = {
    username: username,
    email: email,
    kilma: hashedKilma,
    skilma: hashedSkilma,
  };
  try {
    const res = await fetch(addUserURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    console.log(`res.status: ${res.status}.`);
    if (res) {
      console.log("add user is sent successfully");
      const data = await res.json();
      data.status = res.status;
      return data;
    }
  } catch (error) {
    console.log("Unable to add user.");
    return null;
  }
};

const userLogin_local = async (email, kilma) => {
  let data = { email: email, kilma: kilma };
  try {
    const res = await fetch(userLoginURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    console.log(`res.status: ${res.status}.`);
    if (res.ok) {
      console.log("login is sent successfully");
      const data = await res.json();
      return data;
    }
  } catch (error) {
    console.log("Unable to login.");
    return null;
  }
};

const userLogout_local = async () => {
  try {
    const res = await fetch(userLogoutURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
    console.log(`res.status: ${res.status}.`);
    if (res) {
      console.log("logout is sent successfully");
      return;
    }
  } catch (error) {
    console.log("Unable to logout.");
    return null;
  }
};

const addProduct_local = async (product) => {
  let data = { product: product };
  try {
    const res = await fetch(productURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    console.log(`res.status: ${res.status}.`);
    if (res.ok) {
      console.log("add-product request is successfully handled by server.");
      const data = await res.json();
      return data;
    }
  } catch (error) {
    console.log("Unable to process add-product in client, return null.");
    return null;
  }
};

const fetchProducts_local = async () => {
  console.log("fetchProducts_local is called by fetchProducts.");
  try {
    const res = await fetch(productsURL, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
    console.log(`res.status: ${res.status}.`);
    if (res.ok) {
      console.log("fetch-products request is successfully handled by server.");
      const data = await res.json();
      return data;
    }
  } catch (error) {
    console.log("Unable to process fetch-products in client, return null.");
    return null;
  }
};

const deleteProduct_local = async (id, name) => {
  let data = { id: id, name: name };

  try {
    const res = await fetch(productURL, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    console.log(`res.status: ${res.status}.`);
    if (res.ok) {
      console.log("delete-product request is successfully handled by server.");
      const data = await res.json();
      return data;
    }
  } catch (error) {
    console.log("Unable to process delete-product in client, return null.");
    return null;
  }
};

/**
 * This method fetches from given URL without redirecting to /login on 401 Unauthorized
 * @param {*} url
 * @param {*} options
 * @returns
 * */
const fetchWithoutRedirect = async (url, options = {}) => {
  try {
    const res = await fetch(url, {
      ...options,
      //credentials: "include", // Always include cookies
      headers: {
        "Content-Type": "application/json",
        ...(options.headers || {}),
      },
    });

    // Handle 401 Unauthorized
    if (res.status === 400 || res.status === 401 || res.status === 403) {
      console.error(
        `res.status: ${res.status}, unauthorized access to ${url}. Do NOT redirect to /login.`,
      );
      return null; // Ensure subsequent code does not execute
    }

    // Return the response or parsed JSON data
    if (res.ok) {
      return await res.json();
    } else {
      console.error(`Request to ${url} failed with status ${res.status}.`);
      return null;
    }
  } catch (error) {
    console.error(`Error fetching from ${url}: ${error}`);
    return null;
  }
};

/********************************************************************************
 * *****************************************************************************
 * *****************************************************************************
 * *****************************************************************************
 * *****************************************************************************
 * ******************************************************************************
 */

export const userLoginAPI = (email, kilma, setLoginResponse) => {
  console.log(`This is userLoginAPI, email: ${email}.`);
  userLogin_local(email, kilma).then((data) => {
    if (data) {
      console.log(
        `This is userLoginAPI, response data is: ${JSON.stringify(data)}.`,
      );
      setLoginResponse(data);
    } else {
      setLoginResponse({
        success: false,
        email: email,
        errorMessage: "Unable to login.",
      });
    }
  });
};

export const userLogoutAPI = async () => {
  console.log("This is userLogoutAPI.");
  await userLogout_local();
};

export const addUserAPI = (
  username,
  email,
  hashedKilma,
  hashedSkilma,
  setAddUserResponse,
) => {
  console.log(`This is addUserAPI, username: ${username}.`);
  addUser_local(username, email, hashedKilma, hashedSkilma).then((data) => {
    if (data) {
      console.log(
        `This is addUserAPI, response data is: ${JSON.stringify(data)}.`,
      );
      setAddUserResponse(data);
    } else {
      setAddUserResponse({
        success: false,
        username: username,
        errorMessage: "Unable to add user.",
      });
    }
  });
};

/**
 * This method communicates with API to reset password (reset-password email is sent to user)
 * @param {*} email
 * @param {*} setForgotPasswordResponse
 * */
export const forgotPasswordAPI = async (email, setForgotPasswordResponse) => {
  let result;

  console.log(`This is forgotPasswordAPI email: ${email}.`);

  try {
    const data = await fetchWithoutRedirect(passwordURL, {
      method: "PUT",
      body: JSON.stringify({
        email: email,
      }),
    });

    if (data === null || typeof data === "undefined") {
      console.error("forgotPassword response is undefined.");
      result = {
        success: false,
        errorMessage: "forgotPassword response is undefined.",
      };
      setForgotPasswordResponse(result);
    } else {
      setForgotPasswordResponse(data);
    }
  } catch (error) {
    console.error(`Error putting to ${passwordURL}: ${error}`);
    setForgotPasswordResponse({
      success: false,
      errorMessage: "Error putting to password url.",
    });
  }
};

/**
 * This method communicates with API to reset password (new password is set)
 * @param {*} email
 * @param {*} token
 * @param {*} ukilma
 * @param {*} kilma
 * @param {*} setResetPasswordResponse
 * */
export const resetPasswordAPI = async (
  email,
  token,
  ukilma,
  kilma,
  setResetPasswordResponse,
) => {
  let result;

  console.log(
    `This is resetPasswordAPI email: ${email}, token: ${token}, ukilma: ${ukilma}, kilma: ${kilma}.`,
  );

  fetchWithoutRedirect(passwordURL, {
    method: "PATCH",
    body: JSON.stringify({
      email: email,
      token: token,
      ukilma: ukilma,
      kilma: kilma,
    }),
  })
    .then((data) => {
      if (data === null || typeof data === "undefined") {
        console.error("resetPassword response is undefined.");
        result = {
          success: false,
          errorMessage: "Reset-password response is undefined",
        };
        setResetPasswordResponse(result);
      } else {
        setResetPasswordResponse(data);
      }
    })
    .catch((error) => {
      console.error(`Error posting to ${passwordURL}: ${error}`);
      setResetPasswordResponse({
        success: false,
        errorMessage: "Unable to send reset-password request",
      });
    });
};

export const readSerialNumber = (setGetSerialNumberResponse) => {
  console.log("This is readSerialNumber");
  fetchSerialNumber_local().then((data) => {
    if (data) {
      console.log(
        `data received in readSerialNumber: ${JSON.stringify(data)}.`,
      );
      setGetSerialNumberResponse(data);
    } else {
      setGetSerialNumberResponse({
        success: false,
        errorMessage: "Unable to read serial number.",
      });
    }
  });
};

export const sendQRCodeRange = (payload, setSendQRCodeRangeResponse) => {
  console.log(
    `This is sendQRCodeRange, payload is: ${JSON.stringify(payload)}.`,
  );
  sendQRCodeRange_local(payload).then((data) => {
    if (data) {
      console.log(
        `This is sendQRCodeRange, response data is: ${JSON.stringify(data)}.`,
      );
      setSendQRCodeRangeResponse(data);
    } else {
      setSendQRCodeRangeResponse({
        success: false,
        errorMessage: "Unable to send QR code range.",
      });
    }
  });
};

export const enquireBox = (serialNumber, setEnquiryResponse) => {
  console.log(
    `This is enquireBox api function, serial number is: ${serialNumber}.`,
  );
  enquireBox_local({ serialNumber }).then((data) => {
    if (data) {
      console.log(
        `This is enquireBox api, response data is: ${JSON.stringify(data)}.`,
      );
      setEnquiryResponse(data);
    } else {
      setEnquiryResponse(null);
    }
  });
};

export const addBox = (box, setNewAddBoxResponse) => {
  console.log(`This is addBox api function, box is: ${JSON.stringify(box)}`);
  //set data to box and add a prameter to indicate that we are adding a box using box object
  addBox_local({ addUsingSN: false, ...box }).then((data) => {
    if (data) {
      console.log(
        `This is addBox api, response data is: ${JSON.stringify(data)}.`,
      );
      setNewAddBoxResponse(data);
    } else {
      setNewAddBoxResponse({
        success: false,
        errorMessage: "Unable to add box.",
      });
    }
  });
};

export const addBoxUsingSerialNumber = (
  serialNumber,
  setAddBoxUsingSerialNumberResponse,
) => {
  console.log(
    `This is addBoxUsingSerialNumber api function, serialNumber is: ${serialNumber}`,
  );
  addBox_local({ addUsingSN: true, serialNumber: serialNumber }).then(
    (data) => {
      if (data) {
        console.log(
          `This is addBoxUsingSerialNumber api, response data is: ${JSON.stringify(
            data,
          )}.`,
        );
        setAddBoxUsingSerialNumberResponse(data);
      } else {
        setAddBoxUsingSerialNumberResponse(null);
      }
    },
  );
};

/*export const removeBox = (box, setNewRemoveBoxResponse) => {
  console.log(`This is removeBox api function, box is: ${JSON.stringify(box)}`);
  removeBox_local({ removeUsingSN: false, ...box }).then((data) => {
    if (data) {
      console.log(
        `This is removeBox api, response data is: ${JSON.stringify(data)}.`,
      );
      setNewRemoveBoxResponse(data);
    } else {
      setNewRemoveBoxResponse(null);
    }
  });
};*/

//remove box using serial number
export const removeBoxUsingSerialNumber = (
  serialNumber,
  setRemoveBoxUsingSerialNumberResponse,
) => {
  console.log(
    `This is removeBoxUsingSerialNumber api function, serialNumber is: ${serialNumber}`,
  );
  removeBox_local({ serialNumber: serialNumber }).then(
    (data) => {
      if (data) {
        console.log(
          `This is removeBoxUsingSerialNumber api, response data is: ${JSON.stringify(
            data,
          )}.`,
        );
        setRemoveBoxUsingSerialNumberResponse(data);
      } else {
        setRemoveBoxUsingSerialNumberResponse(null);
      }
    },
  );
};

export const fetchDataStats = (setDataStats) => {
  console.log("This is fetchDataStats");
  fetchStats().then((data) => {
    if (data) {
      console.log(JSON.stringify(data));
    }

    if (data === null || typeof data === "undefined") {
      console.log("Fetched stats data is undefinied.");
      setDataStats(null);
    } else {
      setDataStats(data);
    }
  });
};

export const addProduct = (product, setAddProductResponse) => {
  console.log(`This is addProduct api function`);
  addProduct_local(product).then((data) => {
    if (data) {
      console.log(
        `This is addProduct api, response data is: ${JSON.stringify(data)}.`,
      );
      setAddProductResponse(data);
    } else {
      setAddProductResponse({
        sucess: false,
        errorMessage: "Unable to get response from server.",
      });
    }
  });
};

export const fetchProducts = (setFetchProductsResponse) => {
  console.log("This is fetchProducts");
  fetchProducts_local().then((data) => {
    if (data) {
      console.log(`data is received after fetchProducts...`);
      setFetchProductsResponse(data);
    } else {
      setFetchProductsResponse({
        success: false,
        errorMessage: "Unable to fetch products.",
      });
    }
  });
};

export const deleteProduct = (id, name, setDeleteProductResponse) => {
  console.log(`This is deleteProduct api function`);
  deleteProduct_local(id, name).then((data) => {
    if (data) {
      console.log(
        `This is deleteProduct api, response data is: ${JSON.stringify(data)}.`,
      );
      setDeleteProductResponse(data);
    } else {
      setDeleteProductResponse({
        sucess: false,
        errorMessage: "Unable to get response from server.",
      });
    }
  });
};
